import { z } from 'zod';
export var TiersAccountForm;
(function (TiersAccountForm) {
    TiersAccountForm["ADMINISTRATOR"] = "ADMINISTRATOR";
    TiersAccountForm["SIGNATAIRE"] = "SIGNATAIRE";
    TiersAccountForm["CONTRIBUTOR"] = "CONTRIBUTOR";
    TiersAccountForm["OWNER"] = "OWNER";
})(TiersAccountForm || (TiersAccountForm = {}));
export const TiersLinkedAccountSchema = z.object({
    href: z.string(),
    form: z.nativeEnum(TiersAccountForm),
    title: z.string().optional(),
    rel: z.string().optional(),
    organisation: z.string().optional(),
});
export const TiersLinkedAccountExpandedSchema = TiersLinkedAccountSchema.extend({
    expand: z
        .object({
        franceConnect: z.boolean().optional(),
        name: z
            .object({
            honorificPrefix: z.string().optional(),
            familyName: z.string().optional(),
            givenName: z.string().optional(),
        })
            .optional(),
        userName: z.string(),
        emails: z.array(z.string()).optional(),
    })
        .optional(),
});
export const TiersLinkedAccountListExpandedSchema = z.array(TiersLinkedAccountExpandedSchema);
const TiersAccountRestrictionSchema = z.object({
    userId: z.string(),
    allowedTeleservices: z.array(z.string()),
});
export const TiersAccountRestrictionListSchema = z.object({
    tiersId: z.string(),
    usersRestrictions: z.array(TiersAccountRestrictionSchema),
});
//# sourceMappingURL=tiers-account.js.map